<!-- 压力-上传中断报警设置 -->
<template>
  <div>
    <a-card style="width: 100%; text-align: center">
      <div class="table-page-search-wrapper">
        <a-form layout="inline" style="margin: 20px 0px 0px 20px">
          <a-row :gutter="12">
            <a-col :md="6" :sm="12">
              <a-form-item label="水表名称">
                <a-input v-model="query.deviceName" placeholder="请输入" allow-clear />
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="12">
              <a-form-item label="水表编号">
                <a-input v-model="query.deviceNo" placeholder="请输入" allow-clear />
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="12" style="display: flex">
              <a-button type="primary" @click="queryList">查询</a-button>
              <a-button style="margin-left: 12px" @click="resetList">重置</a-button>
              <a-button type="primary" style="margin-left: 12px" @click="title = '新增'; addOrUpdateHandle()">新增</a-button>
              <a-button type="danger" style="margin-left: 12px" @click="deleteSelectRow()">删除</a-button>
            </a-col>
          </a-row>
        </a-form>
      </div>
      <a-table ref="table" rowKey="id" :columns="columns"
        :row-class-name="(_record, index) => (index % 2 === 1 ? 'table-striped' : null)"
        :row-selection="{ selectedRowKeys: this.selectedRows, onChange: onSelectChange }" :data-source="list"
        :pagination="pagination" @change="pageChange" bordered>
        <span slot="action" slot-scope="text, record">
          <a @click="Handle(record)">编辑</a>
        </span>
        <span slot="pmtNameSlot" slot-scope="text">
          数据上传中断报警
        </span>
        <span slot="collectionFrequency" slot-scope="text">
          {{ text }}分钟/次
        </span>
        <span slot="openState" slot-scope="text">
          <a-tag color="#f12b35" v-if="text == 0">不开启</a-tag>
          <a-tag color="rgb(50, 205, 50)" v-else>开启</a-tag>
        </span>
      </a-table>
      <a-modal :title="title" width="50%" v-model="addOrUpdateVisible" @ok="handleOk" @cancel="handleCancel">
        <a-form :form="addOrUpdateForm" :label-col="{ span: 5 }" :wrapper-col="{ span: 12 }">
          <a-form-item label="设备名称">
            <div class="pressure-interrupt-device-select-wrap">
              <a-select
                class="pressure-interrupt-device-select"
                v-decorator="['deviceNo', { rules: [{ required: true, message: '请选择设备名称' }] }]"
                :disabled="disabled"
                placeholder="请选择设备名称"
                show-search
                option-filter-prop="children"
                :filter-option="filterPressureInterruptDeviceOption"
                :get-popup-container="(trigger) => trigger.parentNode"
                dropdown-class-name="pressure-interrupt-device-select-dropdown"
              >
                <a-select-option
                  v-for="(item, index) in equipmentList"
                  :key="item.deviceNo || index"
                  :value="item.deviceNo"
                  :title="item.title"
                >
                  {{ item.title }}
                </a-select-option>
              </a-select>
              <a class="pressure-interrupt-device-copy-link" href="javascript:;" @click="copyPressureInterruptDeviceName">复制名称</a>
            </div>
          </a-form-item>
          <a-form-item label="计量仪表数据采集频率">
            <div style="display: flex;align-items: center;">
              <a-select style="width: 50%;"
                v-decorator="['collectionFrequency', { rules: [{ required: true, message: '请选择' }] }]"
                placeholder="请选择">
                <a-select-option v-for="(item, index) in collectionFrequencyList" :key="index" :value="item.value">
                  {{ item.title }}
                </a-select-option>
                <a-select-option :value="0">
                  {{ '自定义' }}
                </a-select-option>
              </a-select>
              <span v-if="addOrUpdateForm.getFieldValue('collectionFrequency') != '0'" style="margin-left: 10px;">
                分钟/次</span>
            </div>
            <div v-if="addOrUpdateForm.getFieldValue('collectionFrequency') == '0'"
              style="display: flex;margin-top: 20px;">
              <a-input v-decorator="['num', {
                rules: [{ required: true, message: '请输入', trigger: 'blur' },
                { pattern: /^[1-9]\d*$/, message: '请输入正整数', trigger: 'change' }]
              }]" placeholder="请输入" allow-clear />
              <a-select v-model="Minutesorhours" placeholder="请选择">
                <a-select-option value="分钟"> 分钟/次 </a-select-option>
                <a-select-option value="小时"> 小时/次 </a-select-option>
              </a-select>
            </div>
          </a-form-item>
          <a-form-item label="是否开启报警">
            <a-radio-group v-decorator="['openState', { initialValue: 0, rules: [{ required: true }] }]"
              style="width: 100%">
              <a-radio :value="0">不开启</a-radio>
              <a-radio :value="1">开启</a-radio>
            </a-radio-group>
          </a-form-item>
        </a-form>
      </a-modal>
    </a-card>
  </div>
</template>

<script>
import mixinViewModule from '@/mixin/common'

export default {
  mixins: [mixinViewModule],
  data() {
    return {
      currentId: '',
      title: '新增',
      isUpdate: false,
      disabled: false,
      equipmentList: [],
      queryUrl: '/pipe-network/data_interruption_alarm_setting/page',
      addOrUpdateUrl: '/pipe-network/alarm_tsl_configs',
      deleteUrl: '/pipe-network/data_interruption_alarm_setting/delete',
      queryOneUrl: '/pipe-network/data_interruption_alarm_setting/get',
      addOrUpdateVisible: false,
      confirmLoading: false,
      list: [],
      collectionFrequencyList: [
        {
          title: '5',
          value: '5'
        }, {
          title: '10',
          value: '10'
        }, {
          title: '15',
          value: '15'
        }, {
          title: '30',
          value: '30'
        }, {
          title: '60',
          value: '60'
        },
      ],
      query: {
        deviceNo: '',
        deviceName: '',
        alarmType: 3
      },
      Minutesorhours: '分钟',
      columns: [
        {
          title: '分区计量仪表',
          dataIndex: 'deviceName',
        },
        {
          title: '报警类型',
          dataIndex: 'pmtName',
          scopedSlots: { customRender: 'pmtNameSlot' }
        },
        {
          title: '是否开启报警',
          dataIndex: 'openState',
          scopedSlots: { customRender: 'openState' }
        },
        {
          title: '分区计量仪表数据采集频率',
          dataIndex: 'collectionFrequency',
          scopedSlots: { customRender: 'collectionFrequency' }
        },
        {
          title: '更改时间',
          dataIndex: 'updateTime'
        },
        {
          title: '操作',
          dataIndex: 'action',
          width: 150,
          scopedSlots: { customRender: 'action' }
        }
      ],
      addOrUpdateForm: this.$form.createForm(this, { name: 'addOrUpdate' }),
    }
  },
  mounted() {
    this.queryList()
  },
  created() {
    this.resetList()
    this.equipmentSelect()
    this.queryList()
  },
  methods: {
    filterPressureInterruptDeviceOption(input, option) {
      const text =
        option.componentOptions &&
        option.componentOptions.children &&
        option.componentOptions.children[0] &&
        option.componentOptions.children[0].text
      if (!text) return false
      return String(text).toLowerCase().indexOf(String(input).toLowerCase().trim()) >= 0
    },
    copyPressureInterruptDeviceName() {
      const deviceNo = this.addOrUpdateForm.getFieldValue('deviceNo')
      if (deviceNo === undefined || deviceNo === null || deviceNo === '') {
        this.$message.warning('请先选择设备名称')
        return
      }
      const item = this.equipmentList.find((e) => String(e.deviceNo) === String(deviceNo))
      const text = item ? item.title : String(deviceNo)
      const ok = () => this.$message.success('已复制到剪贴板')
      const err = () => this.$message.error('复制失败，请重试')
      if (navigator.clipboard && typeof navigator.clipboard.writeText === 'function') {
        navigator.clipboard.writeText(text).then(ok).catch(err)
        return
      }
      const ta = document.createElement('textarea')
      ta.value = text
      ta.setAttribute('readonly', 'readonly')
      ta.style.position = 'fixed'
      ta.style.opacity = '0'
      ta.style.left = '-9999px'
      document.body.appendChild(ta)
      ta.select()
      try {
        if (document.execCommand('copy')) {
          ok()
        } else {
          err()
        }
      } catch (e) {
        err()
      }
      document.body.removeChild(ta)
    },
    resetList() {
      this.query = {
        deviceNo: '',
        deviceName: '',
        alarmType: 3
      }
      this.pagination.current = 1
      this.selectedRows = []
      this.queryList()
    },
    equipmentSelect() {
      this.$http.get('/pipe-network/piezometer/list').then((res) => {
        const list = []
        res.data.map((item) => {
          list.push({
            title: item.piezometerNo + ' ' + item.installAddress,
            deviceNo: item.piezometerNo,
            deviceName: item.piezometerNo + ' ' + item.installAddress,
          })
        })
        this.equipmentList = list
      })
    },
    handleOk() {
      const that = this
      this.addOrUpdateForm.validateFields((err, values) => {
        if (!err) {
          that.confirmLoading = true
          let params = values
          if (values.collectionFrequency == 0) {
            if (this.Minutesorhours == '小时') {
              params.collectionFrequency = values.num * 60
            } else {
              params.collectionFrequency = values.num
            }
          }
          const currentDevice = this.equipmentList.find(item => item.deviceNo === values.deviceNo)
          if (currentDevice) {
            params.deviceNo = currentDevice.deviceNo
            params.deviceName = currentDevice.deviceName
          }
          params.alarmType = 3
          if (!this.currentId) {
            this.$http
              .post('pipe-network/data_interruption_alarm_setting/insert ', params)
              .then((res) => {
                if (res.code == 0) {
                  this.$message.success(res.message)
                  this.addOrUpdateVisible = false
                  this.resetList()
                } else {
                  this.$message.warning(res.message)
                }
              }).finally(() => {
                that.confirmLoading = false
              })
          } else {
            params.id = this.currentId
            this.$http
              .put('pipe-network/data_interruption_alarm_setting/update ', params)
              .then((res) => {
                if (res.code == 0) {
                  this.$message.success(res.message)
                  this.addOrUpdateVisible = false
                  this.resetList()
                } else {
                  this.$message.warning(res.message)
                }
              }).finally(() => {
                that.confirmLoading = false
              })
          }
        }
      })
    },
    Handle(e) {
      this.disabled = true
      this.title = '编辑'
      this.addOrUpdateVisible = true
      this.addOrUpdateHandle(e.id)
      this.currentId = e.id
    },
    showModal() {
      this.addOrUpdateVisible = true
    },
    handleCancel(e) {
      this.addOrUpdateVisible = false
      this.disabled = false
    }
  }
}
</script>

<style lang="less" scoped>
/deep/.table-striped {
  background-color: #fafafa;
}

/deep/ .ant-table-thead>tr>th> {
  text-align: center;
}

/deep/ .ant-table-tbody>tr>td {
  text-align: center;
}

/deep/ .pressure-interrupt-device-select.ant-select .ant-select-selection,
/deep/ .pressure-interrupt-device-select.ant-select .ant-select-selection__rendered,
/deep/ .pressure-interrupt-device-select.ant-select .ant-select-selection-selected-value,
/deep/ .pressure-interrupt-device-select.ant-select .ant-select-search__field {
  user-select: text !important;
  -webkit-user-select: text !important;
}
/deep/ .pressure-interrupt-device-select.ant-select-disabled .ant-select-selection,
/deep/ .pressure-interrupt-device-select.ant-select-disabled .ant-select-selection__rendered {
  pointer-events: auto !important;
  cursor: text;
}
/deep/ .pressure-interrupt-device-select.ant-select-disabled .ant-select-selection-selected-value {
  pointer-events: auto !important;
  user-select: text !important;
  -webkit-user-select: text !important;
}
/deep/ .pressure-interrupt-device-select-wrap {
  display: flex;
  align-items: center;
  width: 100%;
  gap: 8px;
}
/deep/ .pressure-interrupt-device-select-wrap .pressure-interrupt-device-select {
  flex: 1;
  min-width: 0;
}
/deep/ .pressure-interrupt-device-copy-link {
  flex-shrink: 0;
  white-space: nowrap;
}
</style>

<style lang="less">
.pressure-interrupt-device-select-dropdown .ant-select-dropdown-menu-item {
  user-select: text !important;
  -webkit-user-select: text !important;
}
</style>
